export const DRAW_MODE = {
  CREATE: 1,
  EDIT: 2,
  DISABLE: 3,
};
